export default __webpack_public_path__ + "static/media/Delete.edcef7e2.svg";